import React from 'react';

function Terminal() {
  window.location.reload();
  return (
    <div className="fake-wp d-flex w-100 flex-column flex-md-row">
      <div className="fake-workspace d-flex flex-column w-100">
        <div className="workspace-title-buttons-area flex-wrap d-none d-sm-flex justify-content-between pt-2 pb-1 mb-4">
          Loading your workspaces...
        </div>
      </div>
    </div>
  );
}

export default Terminal;
